module.exports = __webpack_public_path__ + "static/media/calculator.175f033b.png";